import {KpiVisibilityFlag} from '@hconnect/common/types'
import {TFunction} from 'i18next'

export const getVisibilityOptions = (t: TFunction) =>
  Object.values(KpiVisibilityFlag).map((value) => ({
    id: value,
    label: t(`kpiVisibilityFlag.${value}`)
  }))
